<template>
  <div class="ooh-view">
    <div class="content">
      <v-row v-if="hasHTMLTags()">
        <v-col class="text-center" cols="12">
          <div class="oohMessage" v-html="oohData.message"></div>
        </v-col>
      </v-row>
      <v-row v-else align="center" justify="center">
        <v-col class="text-center" cols="12">
          <h1 class="display-1 font-weight-thin mb-4">{{ oohData.message }}</h1>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "OohView",
  computed: {
    ...mapGetters([
      "oohData"
      // ...
    ])
  }, 
  methods: {
    hasHTMLTags() {
      try {
        var a = document.createElement('div');
        a.innerHTML = this.oohData.message;
        for (var c = a.childNodes, i = c.length; i--; ) {
          if (c[i].nodeType == 1) return true; 
        }
      } catch (e) {}
      return false;
    }
  }
};
</script>

<style scoped>
</style>
